import {
  EmployeeHrmsStatus,
  EmployeeStates,
} from "../pages/settings/EmployeeDatasourceSettings";

export interface Result {
  resultCode: string;
  reason: string;
}
export type Role =
  | "ROLE_ADMIN"
  | "ROLE_OPTIONS_CREATOR"
  | "ROLE_OPTIONS_APPROVER"
  | "ADMIN_VIEWER"
  | "ROLE_ESOP_ADMIN"
  | "ROLE_ESOP_VIEWER";
export type GrantStates =
  | "CREATED"
  | "FOR_APPROVAL"
  | "APPROVED"
  | "OFFERED"
  | "GRANTED"
  | "WITHDRAW"
  | "NOT_APPROVED"
  | "OFFER_EXPIRED";

export enum GrantState {
  CREATED = "CREATED",
  FOR_APPROVAL = "FOR_APPROVAL",
  APPROVED = "APPROVED",
  OFFERED = "OFFERED",
  GRANTED = "GRANTED",
  WITHDRAW = "WITHDRAW",
  NOT_APPROVED = "NOT_APPROVED",
  OFFER_EXPIRED = "OFFER_EXPIRED",
}

export interface PlatformError {
  id: string;
  companyId: string;
  status: "unread" | "read";
  type?: "error" | "warning" | "info";
  operation?: string;
  entityType?: string;
  referenceIds?: string[];
  description: string;
  metadata?: Record<string, any>;
  createdAt: Date;
  updatedAt: Date;
}
export interface ReportStatus {
  status: "IN_PROGRESS" | "SUCCESS" | "FAILURE" | "QUEUED";
  reportName: string;
  reportType: HissaReportType;
  message?: string;
  additionalInfo?: any;
  error?: string;
  serverTime?: number;
}
export type InternalTransferMatchField =
  | "name"
  | "email"
  | "hrId"
  | "groupDateOfJoining";
export interface SyncSettings {
  syncFrequency: number;
  dataToSync: string[];
  considerResignationDateForLapsing: boolean;
  autoTransferToPersonalEmail: boolean;
  valuationForGrant?: string;
  vestingScheduleForGrant?: string;
  planForGrant?: string;
  strikePriceForGrant?: string;
  grantType?: string;
  name?: string;
  grantIdentifierTemplate?: string;
  additionalSettings: {
    employeeImportFilter?: {
      new?: {
        status: string[];
      };
      old?: {
        status: string[];
      };
    };
  };
  syncMode: "MANUAL" | "AUTOMATIC" | "";
  requireApprovalForResignation?: boolean;
  autoRaiseRequestForInternalTransfer?: boolean;
  internalTransferMatchFields?: InternalTransferMatchField[];
}

export const StatusOptions = [
  { value: EmployeeHrmsStatus.PENDING },
  { value: EmployeeHrmsStatus.ACTIVE },
  { value: EmployeeHrmsStatus.INACTIVE },
  { value: EmployeeHrmsStatus.RESIGNED },
  { value: EmployeeHrmsStatus.EMPLOYED },
];

export const EmployeeStateOptions = [
  { value: EmployeeStates.NEW_EMPLOYEES },
  { value: EmployeeStates.EXISTING },
  { value: EmployeeStates.ALL },
];

export enum HissaReportType {
  CORPORATE_ACTION = "CORPORATE_ACTION",
  ESOP_ACCOUNTING = "ESOP_ACCOUNTING",
  GRANT_REPORT = "GRANT_REPORT",
  EMPLOYEE_WISE_REPORT = "EMPLOYEE_WISE_REPORT",
  VEST_WISE_REPORT = "VEST_WISE_REPORT",
  CANCELLATION_REPORT = "CANCELLATION_REPORT",
  EXERCISE_REPORT = "EXERCISE_REPORT",
  LIQUIDITY_REPORT = "LIQUIDITY_REPORT",
  BUYBACK_REPORT = "BUYBACK_REPORT",
  POOL_STATEMENT = "POOL_STATEMENT",
  ACCEPTANCE_REPORT = "ACCEPTANCE_REPORT",
  FINANCIAL_REPORT = "FINANCIAL_REPORT",
  SH6_REPORT = "SH6_REPORT",
  SECTION_10_C_REPORT = "SECTION_10_C_REPORT",
  SEBI_REPORT = "SEBI_REPORT",
  CASHOUT_REPORT = "CASHOUT_REPORT",
}

export interface ScheduleParams {
  recipients: string[];
  intervalDays: number;
}

export type Schedulable<T> = T & { scheduleParams?: ScheduleParams };

export interface ScheduledReport {
  id: string;
  companyId: string;
  reportType: HissaReportType;
  params: Record<string, unknown>;
  recipients: string[];
  intervalDays: number;
  isActive: boolean;
  lastRunAt: string | null;
  nextRunAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateScheduleRequest {
  params?: Record<string, unknown>;
  recipients?: string[];
  intervalDays?: number;
  isActive?: boolean;
  reportType?: HissaReportType;
}
